import script from "./CustomInputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomInputField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomInputField.vue?vue&type=style&index=0&id=650d331d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650d331d"]])

export default __exports__